import { Environment } from '@qtek/shared/models';

export const environment: Environment = {
  production: true,
  title: 'synply-prod',
  rest: {
    protocol: 'https',
    hostname: 'api.synply.io',
    path: '',
  },
  websocket: {
    protocol: 'wss',
    hostname: 'wsapi.synply.io',
    path: '',
  },
  taskServer: {
    protocol: 'https',
    hostname: 'task.synply.io',
    path: '',
  },
  debugTranslations: false,
  dataDogRumEnabled:
    (process.env['QT_DATADOG_RUM_ENABLED'] as string)?.toLowerCase() === 'true',
  dataDogRumApiId: process.env['QT_DATADOG_RUM_API_ID_LFE'],
  dataDogRumClientToken: process.env['QT_DATADOG_RUM_CLIENT_TOKEN_LFE'],
  dataDogRumSessionSampleRate:
    parseInt(process.env['QT_DATADOG_RUM_SAMPLE_SESSION_RATE'], 10) || 0,
  dataDogRumSessionReplaySampleRate:
    parseInt(process.env['QT_DATADOG_RUM_REPLAY_SESSION_RATE'], 10) || 0,
  dataDogRumService: process.env['QT_DATADOG_RUM_SERVICE'],
  dataDogRumEnv: process.env['QT_DATADOG_RUM_ENV'],
  intercomEnabled: true,
  intercomAppId: 'sz6gu58b',
  mixpanelEnabled: true,
  mixpanelToken: 'c642ab3019a224a1ba268cea0718fe7f',
  mixpanelEnv: 'production',
};
